import ClinicsDropdown from "lib/components/common/dashboard/clinics-dropdown";
import SimpleCard from "lib/components/common/simple-card";
import SimpleDataTable from "lib/components/common/simple-data-table";
import DashboardLayout from "lib/components/layouts/dashboard";
import { ALL_CLINIC_OPTION } from "lib/constants";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import { APPOINTMENTS_COLUMNS } from "lib/constants/table-columns";
// import { DUMMY_APPOINTMENTS } from "lib/data/dummy-appointments";
import useClinics from "lib/hooks/useClinics";
import { useEffect, useState } from "react";
const breadcrumbItems = [
  {
    label: "Dashboard",
    path: PAGE_ROUTES.ADMIN.Dashboard,
  },
  {
    label: "Appointments",
    path: PAGE_ROUTES.ADMIN.DashboardAppointments,
  },
] as BreadcrumbItem[];

const DashboardAppointmentsPage = () => {
  const [selectedClinic, setSelectedClinic] = useState<Clinic | null>(
    ALL_CLINIC_OPTION
  );
  const { clinics, getClinics, loading } = useClinics();

  useEffect(() => {
    getClinics(false);
  }, []);

  return (
    <DashboardLayout breadcrumbItems={breadcrumbItems}>
      <SimpleCard
        title="Appointments"
        isLoading={loading}
        action={
          <ClinicsDropdown
            className="w-25"
            isShowAll={true}
            clinics={clinics ?? []}
            onSelect={setSelectedClinic}
            selectedClinic={selectedClinic}
          />
        }
      >
        <SimpleDataTable
          columns={APPOINTMENTS_COLUMNS}
          data={[]}
        ></SimpleDataTable>
      </SimpleCard>
    </DashboardLayout>
  );
};

export default DashboardAppointmentsPage;
